import React, { useEffect, useMemo, useState } from 'react';
import { Card, Select, Space, Typography } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import QaqcPipeWeldtypeCreate from './QaqcPipeWeldtypeCreate';
import type { QaqcPipeWeldtype } from '../../../../types';
import { fetchSqlData } from '../../../../services/api';
import { useGetQaqcPipeWeldtype } from '../../../../hooks/genericHooks';

const QaqcPipeWeldtypeView: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [record, setRecord] = useState<QaqcPipeWeldtype | undefined>(undefined);
  const { data: listResp } = useGetQaqcPipeWeldtype();

  useEffect(() => {
    const load = async () => {
      if (record) return;
      const id = params.id ? Number(params.id) : NaN;
      if (!Number.isFinite(id)) return;
      try {
        const res = await fetchSqlData('qaqc_pipe_weldtype', 'id', id);
        const row = Array.isArray(res?.data) ? res.data[0] : (Array.isArray(res) ? res[0] : undefined);
        if (row) setRecord(row as QaqcPipeWeldtype);
      } catch {}
    };
    load();
  }, [params.id]);

  const goBack = () => navigate(-1);

  const options = useMemo(() => {
    const rows: QaqcPipeWeldtype[] = (listResp?.data as any) || [];
    return rows.map(w => ({ value: (w as any).id, label: `${w.weldtype_name} (kind ${w.weldtype_kind})`, rec: w }));
  }, [listResp]);

  const missingId = !record && !(params.id && Number.isFinite(Number(params.id)));

  return (
    <>
      <style>{`
        .weldtype-no-shade .ant-input[disabled],
        .weldtype-no-shade .ant-input-affix-wrapper-disabled,
        .weldtype-no-shade .ant-select-disabled .ant-select-selector,
        .weldtype-no-shade .ant-input-number-disabled .ant-input-number-input {
          background-color: transparent !important;
          color: inherit !important;
        }
        .weldtype-no-shade .ant-select-disabled .ant-select-selection-item,
        .weldtype-no-shade .ant-select-disabled .ant-select-arrow {
          color: inherit !important;
        }
      `}</style>
      <div className="weldtype-no-shade">
        <Space direction="vertical" style={{ width: '100%' }} size={8}>
          {missingId && (
            <Card size="small" title={<Typography.Text strong>Select a weld type to view</Typography.Text>}>
              <Select
                showSearch
                allowClear
                placeholder="Search weld type"
                style={{ width: 420 }}
                options={options}
                optionFilterProp="label"
                filterOption={(input, option) => {
                  const label = String(option?.label || '').toLowerCase();
                  const tokens = input.trim().toLowerCase().split(/\s+/).filter(Boolean);
                  return tokens.every(t => label.includes(t));
                }}
                onChange={(val, opt: any) => {
                  const id = Number(val);
                  const rec = opt?.rec as QaqcPipeWeldtype | undefined;
                  if (Number.isFinite(id)) {
                    if (rec) setRecord(rec);
                    navigate(`/qaqc/piping/tools/weldtypes/view/${id}`);
                  }
                }}
              />
            </Card>
          )}
          <QaqcPipeWeldtypeCreate
            mode="edit"
            initialValues={record}
            onBack={goBack}
            viewOnly
          />
        </Space>
      </div>
    </>
  );
};

export default QaqcPipeWeldtypeView;
